import { useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { useNavigate } from 'react-router-dom';
import slidebanklogin from "../assets/flags/slidebanklogin.gif";

interface IProps {
    AlterAdminAuth: () => void;
}

interface IPassword {
    password: string,
}

const schema = yup.object({
    password: yup.string().required("Visa Name is required"),
});

export const AdminAuth = (props: IProps) => {
    const secretPassword = "Amar@12575";
    const [saveDis, setSaveDis] = useState(false);
    const [password, setPassword] = useState<string>("");
    const [vwPassword, setVwPassword] = useState(false);

    const navigate = useNavigate();

    const toast = useRef<any>(null);

    const { control, handleSubmit, watch, formState: { errors }, reset } = useForm<IPassword>({
        resolver: yupResolver(schema),
        defaultValues: {},
        shouldFocusError: false
    });

    const onSubmit = () => {
        if (secretPassword === password) {
            toast.current.show({ severity: 'success', detail: "Login Successfully", life: 3000 });
            props.AlterAdminAuth();
        } else {
            toast.current.show({ severity: 'error', detail: "Password Is Wrong", life: 3000 });
        }
    }

    return (
        <>
            <h1 style={{ width: "100%", textAlign: "center", fontWeight: "bold" }} className="mt-5">Admin Authentication Password</h1>
            <form onSubmit={handleSubmit(onSubmit)} className="flex justify-content-center align-content-center" style={{ height: "80vh" }}>
                <div className="w-4 h-full flex flex-column justify-content-between border-3 border-blue-400 border-round-2xl p-5">
                    <div style={{height: "30%"}}>
                        <img src={slidebanklogin} alt="slidebanklogin" className="summary-box-graph my-0 w-full" />
                    </div>
                    <div>
                        <div className="p-inputgroup flex-1">
                            <InputText placeholder="Enter Secret Password" value={password} className="h-7rem" type={vwPassword ? "text" : "password"} onChange={(e) => setPassword(e.target.value)} />
                            {!vwPassword && <Button icon="pi pi-eye" className="border-none surface-600 h-7rem" onClick={() => setVwPassword(prev => prev = true)} />}
                            {vwPassword && <Button icon="pi pi-eye-slash" className="border-none surface-600 h-7rem" onClick={() => setVwPassword(prev => prev = false)} />}
                        </div>
                    </div>
                    <div className="flex flex-column gap-1 mt-5">
                        <Button className="field col md:col h-3rem" label="SAVE" type="button" disabled={saveDis} onClick={() => onSubmit()}></Button>
                        <Button className="field col md:col p-button-outlined h-3rem" label="CLEAR" onClick={() => { setPassword(""); reset({}); }} type="button"></Button>
                        <Button className="field col md:col h-3rem" label="LOGOUT" onClick={() => {
                            sessionStorage.clear();
                            props.AlterAdminAuth();
                            navigate('/');
                        }} type="button"></Button>
                    </div>
                </div>
            </form>
            <Toast ref={toast} />
        </>
    );
}